export enum StatementStatus {
    RESOLVED = 'resolved',
    FAILED = 'failed'
}

export interface Statement {
    _id: string;
    recordNumber: number;
    actionStatus: StatementStatus.RESOLVED | StatementStatus.FAILED;
    amount: number;
    createdAt: string;
    transactionInfo: string;
    actionNote: string;
    description: string;
    updatedAt: string;
    bankType: string;
    relatedAccount: string;
}